import { Routes, Route } from 'react-router-dom';
import Position from '../child_components/Position';
import Profile from '../child_components/Profile';
import EmployeeTree from '../child_components/EmployeeTree';

function Employee() {
    

    return(
        <div className="flex w-full pt-10">
            <Routes>
                <Route path='/profile' element={ <Profile /> } />
                <Route path='/position' element={ <Position /> } />
                <Route path='/' element={ <EmployeeTree /> } />
            </Routes>
        </div>
    )
}

export default Employee;